'use strict';

import { Component } from 'react';
import PropTypes from 'prop-types';
import './ClickableTooltip.scss';

/**
 * A tooltip component that opens on click instead of hover.
 * Useful for mobile-friendly tooltips and when you need the tooltip to stay open.
 */
export default class ClickableTooltip extends Component {
    static propTypes = {
        element: PropTypes.node.isRequired,
        children: PropTypes.node.isRequired,
        className: PropTypes.string,
    };

    static contextTypes = {
        isMobile: PropTypes.bool,
    };

    constructor(props) {
        super(props);
        this.state = {
            isVisible: false,
            position: 'bottom', // default position
        };
        this.tooltipRef = null;
        this.triggerRef = null;
    }

    componentDidMount() {
        if (process.browser) {
            window.addEventListener('mousedown', this.handleOutsideClick);
        }
    }

    componentWillUnmount() {
        if (process.browser) {
            window.removeEventListener('mousedown', this.handleOutsideClick);
        }
    }

    handleOutsideClick = (e) => {
        if (this.tooltipRef && !this.tooltipRef.contains(e.target)) {
            this.setState({ isVisible: false });
        }
    };

    checkPosition = () => {
        if (!this.triggerRef || !process.browser) return;
        
        const triggerRect = this.triggerRef.getBoundingClientRect();
        const spaceBelow = window.innerHeight - triggerRect.bottom;
        const spaceAbove = triggerRect.top;
        
        // If not enough space below (less than 200px) and more space above, position on top
        if (spaceBelow < 200 && spaceAbove > spaceBelow) {
            this.setState({ position: 'top' });
        } else {
            this.setState({ position: 'bottom' });
        }
    };

    toggleTooltip = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState((prevState) => ({ isVisible: !prevState.isVisible }), () => {
            if (this.state.isVisible) {
                this.checkPosition();
            }
        });
    };

    render() {
        const { element, children, className } = this.props;
        const { isVisible, position } = this.state;
        const { isMobile } = this.context;

        return (
            <span 
                ref={(ref) => (this.tooltipRef = ref)} 
                className={`el-popup el-popup-${position}-center ${className || ''} el-clickable-tooltip`}
                data-state={isVisible}
            >
                <span ref={(ref) => (this.triggerRef = ref)} onClick={this.toggleTooltip} className="popup-btn">
                    {element}
                </span>
                {isVisible && (
                    <>
                        {isMobile && <div className="tooltip-backdrop" onClick={this.toggleTooltip} />}
                        <div className="popup-dropdown">
                            <div className="popup-content">
                                <div className="triangle"></div>
                                <div className="triangle2"></div>
                                <button className="close-btn" onClick={this.toggleTooltip}>
                                    <i className="icon-close-x" />
                                </button>
                                {children}
                            </div>
                        </div>
                    </>
                )}
            </span>
        );
    }
}